import { CheckOutlined } from "@ant-design/icons";

import { ImageCardProps } from "./types";

import BaseButton from "../Button/BaseButton";

import "./styles.css";

const ImageCard = ({
  title,
  description,
  image,
  onClick,
  isSelected = false,
  selectedBorderColor = "var(--primary-600)",
  disabled = false,
}: ImageCardProps) => {
  return (
    <div
      className={`image-card flex flex-col gap-300 full-width  ${disabled ? "image-card-disabled" : ""}`}
      style={
        isSelected && !disabled
          ? { border: `1px solid ${selectedBorderColor}` }
          : undefined
      }
      onClick={disabled ? undefined : onClick}
    >
      {image && (
        <div className="image-card-image-container flex items-center justify-center">
          <img
            src={image}
            alt={title}
            className={disabled ? "image-disabled" : ""}
          />
        </div>
      )}

      <h3 className="image-card-title header-s-medium">{title}</h3>

      {description && (
        <p className="image-card-description full-height body-m-regular">
          {description}
        </p>
      )}

      <BaseButton
        variant="secondary"
        leadingIcon={isSelected ? <CheckOutlined /> : undefined}
        isFullWidth
        disabled={disabled}
      >
        {isSelected ? "Selected" : "Select"}
      </BaseButton>
    </div>
  );
};

export default ImageCard;
